<template>
  	<div>
 		<canvas ref="canvas" @click="doMove=!doMove" :width="imageWidth" :height="imageHeight" style="position:absolute;left:0px;">  </canvas>
         

 	</div>
</template>

<script>
const width = window.innerWidth;
const height = window.innerHeight;
import gsap from "gsap";

export default {
    props:{
        imageSrc:{default:null},
        pos:{
            type: Object,
            default: () => ({
                x: 0,
                y: 0
            })
        },
        imageSize:{
            type: Object,
            default: () => ({
                w: 200,
                h: 200
            })
        },
},
  data() {
    return {
        index:0,
        bmData:{r:0,g:0,b:0},
        animFrame:null,
        canvas:null,
        context:null,
        imageData:null,
        image:null,
        testX:0,
        testY:125,
        doMove:false,
        
       
       
      
    };
  },
  mounted() {
      this.canvas=this.$refs.canvas
      this.canvasImage();
    
  }, 
  computed:{
     imageWidth(){
         
         return this.imageSize.w
     },
     imageHeight(){
        
         return this.imageSize.h
     }
  },
  methods:{
      
      canvasImage: function(){
        let self=this	
        this.context = this.canvas.getContext('2d');
        this.image = new Image();
        this.image.src = this.imageSrc;
        this.image.addEventListener("load",function(){
            
             self.context.drawImage( self.image,0,0);
            
             self.imageData=self.context.getImageData(0, 0,  self.image.width,  self.image.height);
             self.calcData(0,0)
        },false);
     },
   
    calcData(x,y){
        this.index=(x+y*this.imageWidth)*4
        if(this.imageData){
            this.bmData.r=this.imageData.data[this.index+0]
            this.bmData.g=this.imageData.data[this.index+1]
            this.bmData.b=this.imageData.data[this.index+2]
        }
        
    },
    getData(x,y){
        this.index=(x+y*this.imageWidth)*4
        if(this.imageData){
            return {x:x,y:y,r:this.imageData.data[this.index+0],g:this.imageData.data[this.index+1],b:this.imageData.data[this.index+2]}
        }
    }

  },
  watch:{
      pos(val){
          this.calcData(val.x,val.y)
         
          this.$store.commit('setScanData',{x:val.x,y:val.y,r:this.bmData.r,g:this.bmData.g,b:this.bmData.b})
          //this.$emit('dataChange',this.bmData,val.x,val.y)
      },
      bmData:{
          handler(val){
              console.log("CHANGE",val,this.bmData)
                //this.$emit('dataChange',val,this.pos.x,this.pos.y)
            },
            deep: true   
    },
  
  }
};
</script>


   

<style lang="scss">
.testSpot{
    width:20px;
    height:20px;
    position:absolute;
    top:0px;
    left:0px;
    border-radius:50%;
    border: #fff solid 2px;
}

</style>